import { Controller } from "@hotwired/stimulus"

// 組織セレクトの変更に応じて、その組織に紐付くイベントのみを event_select フレームへ
// サーバー再描画で反映する連動セレクト。組織未選択時はイベントを選択不可にする。
export default class extends Controller {
  static values = { url: String, frame: { type: String, default: "event_select" } }

  update(event) {
    const params = new URLSearchParams({ organization_id: event.target.value })
    Turbo.visit(`${this.urlValue}?${params}`, { frame: this.frameValue })
  }
}
